import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { nyttigTab } from '../../routes';
import { SanityService } from 'src/app/services/sanity/sanity.service';
import { Article } from 'src/app/services/sanity/sanity.types';
import { Router } from '@angular/router';
import { InformationService } from 'src/app/services/notify/information.service';
import { InformationMessage } from 'src/app/services/notify/information.types';

@Component({
  selector: 'app-nyttig',
  templateUrl: './nyttig.page.html',
  styleUrls: ['nyttig.page.scss', '../../logginn/forside.page.scss']
})
export class NyttigPage implements OnInit {
  isApp: boolean;
  isNarrow: boolean;
  showTilbud = true;

  nyheter: Article[];
  tilbud: Article[];
  infoMessages: InformationMessage[] = [];

  constructor(
    public platform: Platform,
    private _sanitizer: DomSanitizer,
    private analyticsService: AnalyticsService,
    private sanityService: SanityService,
    private router: Router,
    public infoService: InformationService
  ) {}

  ngOnInit() {
    this.infoService.getInfoMessages().subscribe({
      next: (res) => {
        this.infoMessages = res.filter((x) => x.aktivert) || [];
      }
    });
    this.isApp = this.platform.is('capacitor');
    this.isNarrow = this.platform.width() <= 991;

    this.sanityService.getNyhetNyttigArticles().then((res) => {
      this.nyheter = res;
    });
    this.sanityService.getTilbudNyttigArticles().then((res) => {
      this.tilbud = res;
    });
  }

  getBackground(background: string) {
    return this._sanitizer.bypassSecurityTrustStyle('url(' + background + ')');
  }

  navToArticle(url: string) {
    this.analyticsService.logEvent_selectContent('nyttig åpne artikkel ' + url);
    const navExtras = {
      state: {
        sender: nyttigTab,
        page: url
      }
    };
    this.router.navigate(['/tabs/nyttig/artikkel'], navExtras);
  }

  setShowTilbud(show: boolean) {
    this.showTilbud = show;
  }
}
